module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Everton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Everton.png
// module id = 2082
// module chunks = 4